import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { DATA_HOOKS } from './constants';

export const weeklyDateNavigationDriverFactory = (base: UniDriver) => {
  const getElementByDataHook = (dataHook) => {
    return base.$(`[data-hook="${dataHook}"]`);
  };

  return {
    ...baseUniDriverFactory(base),

    /**
     * Click on the next week button.
     */
    clickOnNextWeekButton: () => getElementByDataHook(DATA_HOOKS.Next).click(),

    /**
     * Click on the prev week button.
     * */
    clickOnPrevWeekButton: () => getElementByDataHook(DATA_HOOKS.Prev).click(),

    /**
     * Get the header caption text
     */
    getCaptionText: () => getElementByDataHook(DATA_HOOKS.Text).text(),
  };
};

export type WeeklyDateNavigationDriver = ReturnType<
  typeof weeklyDateNavigationDriverFactory
>;
